export default function externalComponent(id, url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('link')
    script.id = id
    script.rel = 'stylesheet'
    script.type = 'text/css'
    script.href = url
    script.media = 'all'
    script.addEventListener('load', () => {
      resolve()
    })
    script.addEventListener('error', () => {
      reject(new Error(`Error loading css ${url}`))
    })
    document.head.appendChild(script)
  })
}